/**
 * Блокировка прокрутки основной страницы при открытом мобильном меню.
 * Класс `noscroll` вешается на `html` и `body`: у `html` задан `overflow-y: auto` в базовых стилях,
 * из‑за этого одного `body { overflow: hidden }` фон всё ещё мог скроллиться.
 *
 * @param {boolean} locked
 */
export function setMobileMenuScrollLock(locked) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const body = document.body;
  if (!root || !body) return;
  if (locked) {
    root.classList.add('noscroll');
    body.classList.add('noscroll');
  } else {
    root.classList.remove('noscroll');
    body.classList.remove('noscroll');
  }
}

